import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const MaterialInfoIcon = () => {
  return <InfoOutlinedIcon htmlColor="#262698" />;
};

export default MaterialInfoIcon;
